import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    preferencesStatusWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      marginBottom: "2rem",
      gap: "4px",
    },
    preferencesStatusDescription: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    preferencesStatusLink: {
      fontWeight: 700,
      textDecoration: "none",
    },
  },
  { name: "PreferencesStatus" },
);

export { useStyles };
